"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@web3-react/core");
var providers_1 = require("@ethersproject/providers");
var misc_1 = require("../constants/misc");
var manager_1 = __importDefault(require("./manager"));
var block_number_1 = __importDefault(require("./block-number"));
var Web3ProviderNetwork = (0, core_1.createWeb3ReactRoot)(misc_1.NETWORK_CONTEXT_NAME);
var NETWORK_POLLING_INTERVALS = {};
function getLibrary(provider) {
    var library = new providers_1.Web3Provider(provider, typeof provider.chainId === 'number'
        ? provider.chainId
        : typeof provider.chainId === 'string'
            ? parseInt(provider.chainId)
            : 'any');
    library.pollingInterval = 15000;
    library.detectNetwork().then(function (network) {
        var networkPollingInterval = NETWORK_POLLING_INTERVALS[network.chainId];
        if (networkPollingInterval) {
            console.debug('Setting polling interval', networkPollingInterval);
            library.pollingInterval = networkPollingInterval;
        }
    });
    return library;
}
var Provider = function (_a) {
    var children = _a.children, other = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(core_1.Web3ReactProvider, __assign({ getLibrary: getLibrary }, { children: (0, jsx_runtime_1.jsx)(Web3ProviderNetwork, __assign({ getLibrary: getLibrary }, { children: (0, jsx_runtime_1.jsx)(manager_1.default, __assign({}, other, { children: (0, jsx_runtime_1.jsx)(block_number_1.default, { children: children }, void 0) }), void 0) }), void 0) }), void 0));
};
exports.default = Provider;
